import { useMutation } from '@tanstack/react-query';

import OffersService from '~/services/OffersService';

// Stale decisions match no checklist row, so nothing the CM sees changes and no cache is invalidated.
export function useReconcileCMChecklist(offerId: string | undefined) {
  return useMutation({
    mutationFn: () => {
      if (!offerId) {
        throw new Error('offerId is required');
      }

      return OffersService.reconcileCMChecklist(offerId);
    },
    onError: (error) => {
      console.warn('CM checklist reconcile failed', error);
    },
  });
}
